import GridPageAbstract from '../../abstract/GridPageAbstract';
import { validationTaskStatuses } from '../statuses';
import { getFileCategory } from '../../../config/fileConfig';
export default class ExportCsvTasksPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'exportCsvTasks';
        this.Server = this.props.context.getState().server.exportCsvTasks;
        this.MenuDisplayType = 'menu';

        this.searchFields = ['name', 'controllerName', 'entityName'];

        this.showDatePicker = true;

        this.disableGlobalEditor = true;
        this.disableAdd = true;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'name',
                    label: 'name',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                },
                {
                    id: 'listRequest',
                    label: 'listRequest',
                    alignRight: false,
                    cell: 'BigText',
                    displayGrid: true,
                },
                {
                    id: 'extraFilter',
                    label: 'extraFilter',
                    alignRight: false,
                    cell: 'BigText',
                    displayGrid: true,
                },
                {
                    id: 'controllerName',
                    label: 'controllerName',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                },
                {
                    id: 'fileId',
                    label: 'file',
                    alignRight: false,
                    cell: 'Upload',
                    object: 'file',
                    fileCategory: getFileCategory('export'),
                    displayGrid: true,
                },
                {
                    id: 'taskStatus',
                    label: 'taskStatus',
                    alignRight: false,
                    cell: 'State',
                    items: Object.keys(validationTaskStatuses),
                    displayGrid: true,
                    disableEditor: true,
                },

                {
                    id: 'user',
                    label: 'user',
                    alignRight: false,
                    cell: 'Select',
                    from: 'users',
                    show: 'email+name',
                    object: 'user',
                    displayGrid: true,
                    disableEditor: true,
                },
                {
                    id: 'dateCreated',
                    label: 'dateCreated',
                    alignRight: false,
                    cell: 'DateTime',
                    displayGrid: true,
                    disableEditor: true,
                },
                {
                    id: 'dateModified',
                    label: 'dateModified',
                    alignRight: false,
                    cell: 'DateTime',
                    displayGrid: true,
                    disableEditor: true,
                },
            ];

        this.state = {
            ...this.state,
            head: this.Head,
        };
    }
}
